// extracted by mini-css-extract-plugin
export var copyableField = "_p7-4";
export var customerBadge = "_p7-0";
export var customerInfoTitle = "_p7-2";
export var details = "_p7-1";
export var dropdownContainer = "_p7-5";
export var dropdownImage = "_p7-6";
export var editAssigneeForm = "_p7-a";
export var editButton = "_p7-3";
export var email = "_p7-7";
export var hidden = "_p7-d";
export var input = "_p7-8";
export var saveButton = "_p7-b";
export var shopifyIcon = "_p7-c";
export var suggestionBadge = "_p7-e";
export var suggestionText = "_p7-f";
export var username = "_p7-9";